import Table from 'features/common/ui/Table/Table'
import { Box, TableBody } from '@mui/material'
import { useAppSelector } from 'app/state'
import { App } from 'features/apps/types'
import AccountAppsTableHeader from './AccountAppsTableHeader'
import AccountAppsTableRow from './AccountAppsTableRow'
import { RequestStatus } from 'features/common'
import Loader from 'features/common/ui/utils/Loader'
import { FormattedMessage } from 'react-intl'
import NoAppsIcon from 'assets/icons/carto-icon-navigation-no-app.svg?react'
import EmptyState from 'features/common/ui/utils/EmptyState'

function AccountAppsTable() {
  const filteredApps = useAppSelector((state) => state.apps.filteredApps)
  const appsStatus = useAppSelector((state) => state.apps.myAppsStatus)
  const searchParam = useAppSelector((state) => state.apps.myAppsListFilter.searchBy)

  const hasApps = filteredApps && filteredApps.length
  const loading = appsStatus === RequestStatus.Pending

  return (
    <>
      {loading && <Loader />}
      {!loading &&
        (hasApps ? (
          <Table>
            <AccountAppsTableHeader />
            <TableBody>
              {filteredApps && filteredApps.map((app: App, idx: number) => <AccountAppsTableRow app={app} key={idx} />)}
            </TableBody>
          </Table>
        ) : (
          <Box mb={1.5}>
            <EmptyState
              tight={true}
              icon={NoAppsIcon}
              caption={
                searchParam ? (
                  <FormattedMessage id="account.cards.apps.notFound" />
                ) : (
                  <FormattedMessage id="apps.emptyState.title" />
                )
              }
            />
          </Box>
        ))}
    </>
  )
}

export default AccountAppsTable
